/**
 * Explicitly test if a value is null or undefined.
 *
 * @param value
 * @returns
 */
export const isEmpty = (value: unknown): value is null | undefined => {
  return value === undefined || value === null;
};
